import { Component, Input, OnChanges, SimpleChange, SimpleChanges } from '@angular/core';
import { Tooth } from '@features/client/order-workflow/models/tooth.model';
import { BaseDataValueMapItem } from '@core/models/base-data-value-map-item.model';
import { Store } from '@ngxs/store';
import { OrderWorkflowSelectors } from '@features/client/order-workflow/state/order-workflow.selectors';
import { map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { Product } from '@features/client/order-workflow/models/product.model';
import { AttributeBaseDataService } from '@core/services/attribute-base-data.service';
import { AsyncPipe } from '@angular/common';
import { AssetExistsPipe } from '@shared/pipes/asset-exists.pipe';

@Component({
  selector: 'app-tooth-icon',
  templateUrl: './tooth-icon.component.html',
  imports: [AsyncPipe, AssetExistsPipe],
})
export class ToothIconComponent implements OnChanges {
  @Input() public isSelected: boolean;
  @Input() public tooth: Tooth;

  public productName: string = '';
  public imageUrl$: Observable<string>;

  constructor(
    private readonly attributeBaseDataService: AttributeBaseDataService,
    private readonly store: Store,
  ) {}

  public ngOnChanges({ isSelected }: SimpleChanges): void {
    this.setImageInfo(isSelected);
    this.setProductName();
  }

  private setProductName(): void {
    const productId = this.tooth?.crown?.orderProducts[0]?.product?.productType?.id;

    if (productId) {
      this.attributeBaseDataService.getById(productId).subscribe((product) => {
        this.productName = product?.label?.length > 3 ? `${product?.label?.substring(0, 3)}...` : product?.label;
      });
    }
  }

  private setImageInfo(isSelected: SimpleChange): void {
    const product = this.store.selectSnapshot(OrderWorkflowSelectors.getProductType)?.product;

    if (product && isSelected.currentValue) {
      this.imageUrl$ = this.getProductIconUrl({
        productType: product.productType,
        productCategory: product.productCategory,
      });
    } else if (this.tooth?.crown?.orderProducts[0]) {
      this.imageUrl$ = this.getProductIconUrl({
        productType: this.tooth?.crown?.orderProducts[0]?.product?.productType,
        productCategory: this.tooth?.crown?.orderProducts[0]?.product?.productCategory,
      });
    } else {
      this.imageUrl$ = of(null);
    }
  }

  private getProductIconUrl(productInfo: Partial<Product>): Observable<string> {
    const productType = productInfo.productType.value;
    const parentProductId = productInfo.productCategory.parent_id;

    if (parentProductId) {
      return this.attributeBaseDataService.getById(parentProductId).pipe(
        map((status: BaseDataValueMapItem) => {
          return `assets/svg/product-types/${status.value}/${productType}.svg`;
        }),
      );
    } else {
      return of(`assets/svg/product-types/${productInfo.productCategory.value}/${productType}.svg`);
    }
  }
}
